module.exports = __webpack_public_path__ + "static/media/hero-curve.adc99bd2.png";